import { device } from 'constants/media-query'
import styled from 'styled-components'
import personalAreaTabBg from '../../assets/images/personal-area-tab-backgroung.png'

export const PersonalAreaBackround = styled.div`
  background: rgba(245, 245, 245, 1);
  margin-top: 0px;
  overflow: visible;
  font-family: ${({ theme }) => theme.fonts.inter}, sans-serif;
`
export const PersonalAreaTitle = styled.div`
  display: flex;
  flex-direction: column;
  text-align: start;
  align-items: flex-start;
  color: #000000; // TODO: change it using theme
  font-family: ${({ theme }) => theme.fonts.inter};

  & > h2 {
    font-size: ${({ theme }) => theme.fontSizes.large};
    font-size: 16px;
    font-weight: 600;
    line-height: 19.36px;
    margin-bottom: 0;
    margin-top: 0;
  }
  @media ${device.desktop} {
    & > h2 {
      font-size: ${({ theme }) => theme.fontSizes.large};
      font-weight: 700; // TODO: change it using theme
      line-height: 29.05px;
      margin-bottom: 8px;
      margin-top: 50px;
    }
  }
`
export const PersonalAreaSubTitle = styled.div`
  display: flex;
  flex-direction: row;
  text-align: start;
  align-items: flex-start;
  gap: 4px;
  & > p {
    margin-top: 2px;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
  }
  @media ${device.desktop} {
    & > p {
      font-size: 14px;
      font-weight: 400;
      line-height: 16.94px;
    }
  }
`
export const PersonalAreaBody = styled.div`
  display: flex;
  flex-direction: column;
  @media ${device.desktop} {
    flex-direction: row;
    align-items: flex-start;
    gap: 16px;
    align-items: flex-start;
    justify-content: center;
  }
`

export const TabContentContainer = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: column;
  background-image: url(${personalAreaTabBg});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 24px 16px;
  border-radius: 4px;
  box-shadow: 0px 4px 16px 0px rgba(39, 39, 39, 0.1);
  min-height: 396px;
  @media ${device.desktop} {
    padding: 24px 32px;
    min-width: unset;
    flex-grow: 1;
    overflow: hidden;
  }
`
